// extracted by mini-css-extract-plugin
export default {"input":"ResetPasswordForm_input__zvY98","errored":"ResetPasswordForm_errored__4yxCY","error":"ResetPasswordForm_error__4sWET","grid":"ResetPasswordForm_grid__SZQOP"};